import { render, staticRenderFns } from "./addClassCtr.vue?vue&type=template&id=3d531893"
import script from "./addClassCtr.vue?vue&type=script&lang=js"
export * from "./addClassCtr.vue?vue&type=script&lang=js"
import style0 from "./addClassCtr.vue?vue&type=style&index=0&id=3d531893&prod&lang=less"
import style1 from "./addClassCtr.vue?vue&type=style&index=1&id=3d531893&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports